import { render } from "./equipamentosForm.vue?vue&type=template&id=e606a514&scoped=true"
import script from "./equipamentosForm.vue?vue&type=script&lang=js"
export * from "./equipamentosForm.vue?vue&type=script&lang=js"

import "./equipamentosForm.vue?vue&type=style&index=0&id=e606a514&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e606a514"]])

export default __exports__